import Fetch from "../../utils/Fetch"
import {getCookie, setCookie} from "@/utils/Cookie";
import executeRecaptcha from "@/utils/ExecuteRecaptcha";

export default {
    namespaced: true,
    state: {
        ticketData: null,
        paymentInstructions: JSON.parse(localStorage.getItem('payment-instructions')) || [],
        ticketsHistory: getCookie('ticketsHistory') ? getCookie('ticketsHistory').split(',') : []
    },
    mutations: {
        setPaymentInstructions(state, data) {
            if (!data) return
            state.paymentInstructions = data
            localStorage.setItem('payment-instructions', JSON.stringify(data))
        },
        setTicketData(state, data) {
            if (!data) return
            state.ticketData = data
        },
        clearTicketData(state) {
            state.ticketData = null
        },
        saveTicket(state, ticket) {
            if (!state.ticketsHistory.length) {
                state.ticketsHistory.push(ticket)
                setCookie('ticketsHistory', ticket, {expires: new Date(new Date().setMonth(new Date().getMonth() + 6)).toUTCString()})
            } else {
                let index = state.ticketsHistory.findIndex(i => i === ticket)
                if (index !== -1) {
                    state.ticketsHistory.splice(index, 1)
                    state.ticketsHistory.unshift(ticket)
                } else {
                    state.ticketsHistory.unshift(ticket)
                }
                setCookie('ticketsHistory', state.ticketsHistory.join(','), {expires: new Date(new Date().setMonth(new Date().getMonth() + 6)).toUTCString()})
            }
        }
    },
    actions: {
        async loadTicketData({commit}, {ticketNum}) {
            const token = await executeRecaptcha()
            const query = new URLSearchParams({ticket: ticketNum, token})
            const response = await Fetch(`loan-payment/data/?${query}`)
            if (response.success) {
                commit('setTicketData', response.data)
                commit('saveTicket', ticketNum)
            }
            return {
                success: response.success,
                message: response.message,
            }
        },
        async loadPayLink({state, rootGetters}, {email, amount, payment_type, binding_id, openPaymentLink = true}) {
            if (!email || !amount || !payment_type) return

            const ticketData = state.ticketData
            const token = await executeRecaptcha()
            const query = new URLSearchParams({
                ticket: ticketData.ticket,
                amount,
                payment_type,
                email,
                inn: ticketData.inn,
                token
            })
            if (rootGetters['user/isTester'] && binding_id) query.set('binding_id', binding_id)
            const response = await Fetch(`loan-payment/${ticketData['debt_percent'] > 0 ? 'percents' : 'loan'}/pay/?${query}`)
            if (response.success) {
                if (openPaymentLink && response.data['payment_link']) window.open(response.data['payment_link'], '_blank')
                return {
                    success: response.success,
                    data: response.data
                }
            } else {
                return {
                    success: response.success,
                    message: response.message
                }
            }
        },
        // eslint-disable-next-line
        async loadPaymentStatus({}, {transaction}) {
            if (!transaction) {
                return {
                    message: 'Платеж не найден',
                    success: false
                }
            }
            let response = await Fetch(`loan-payment/${transaction}/status/`)
            if (response.success) {
                return {
                    data: response.data,
                    success: response.success
                }
            } else {
                return {
                    message: response.message || 'Платеж не найден',
                    success: false
                }
            }
        },
        async loadPaymentInstructions({commit, state}) {
            if (state.paymentInstructions.length) return
            let response = await Fetch(`instructions/`)
            if (response.success) {
                commit('setPaymentInstructions', response.data)
            }
        }
    },
    getters: {
        getTicketData: state => state.ticketData,
        getTicketsHistory: state => state.ticketsHistory,
        getPaymentInstructions: state => state.paymentInstructions,
    }
}
